import { render, staticRenderFns } from "./SaudeCrianca.vue?vue&type=template&id=04da4b7e"
import script from "./SaudeCrianca.vue?vue&type=script&lang=js"
export * from "./SaudeCrianca.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports